import useSWR from "swr";

import { fetcher } from "@aprosoja/api";
import { GetBoardMembersData } from "@aprosoja/types";

const useBoardMembers = () => {
  const { data: boardMembersData } = useSWR<GetBoardMembersData>(
    [`/board-members?status=true`],
    async ([url]) => fetcher(url),
    { revalidateOnMount: true, revalidateOnFocus: false }
  );

  const boardMembers = boardMembersData?.data;

  return { boardMembers };
};

export default useBoardMembers;
